import { createFileRoute } from '@tanstack/react-router';
import { IntegrationsAllRouteView } from '@/pages/workspaces/integrations/routing';
import { LastWorkspaceResolver } from './-components';

function IntegrationsAllRoute() {
  // Resolve the `/workspaces/last` sentinel to a real id. The resolver is non-blocking, so the
  // view derives the id from the pathname and holds on a loader until the rewrite lands.
  //
  // No `appBundle`: this is the migrated URL, which drops the `journeys` segment. The bundle-aware
  // branch rebuilds the target by slicing the path after the bundle prefix, finds no `/journeys/`
  // here, and so redirects to a bare `/workspaces/<id>/journeys` — the Journeys home, with the
  // sub-path silently dropped. It also redirects with the embedded `Navigate`; a Hydra-owned route
  // wants `SafeNavigate`. Omitting it takes the plain branch, which rewrites `/workspaces/last` in
  // place and preserves the rest. The `journeys` twin next door keeps its bundle, and should.
  return (
    <LastWorkspaceResolver>
      <IntegrationsAllRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/all')({
  component: IntegrationsAllRoute,
});
